module.exports = __webpack_public_path__ + "img/caselist6.345094a5.jpg";